import { setInviteStructureModalClose } from 'domain/modal/store/ModalSlice';
import { InviteStructureForm } from 'primary/Components/Profils/User/ActionButton/Forms/InviteStructureForm';
import { WrapperModalAction } from 'primary/Components/Profils/User/ActionButton/Modals/WrapperModalAction';
import { useTranslate } from 'primary/hooks/useTranslate';
import ModalContainer from 'primary/ModalContainer/ModalContainer';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';

export interface ModalInviteStructureProps {
  userId?: number;
  name: string;
}
export const ModalInviteStructure = () => {
  const t = useTranslate();
  const dispatch = useDispatch();
  const stateModal = useSelector((state: RootState) => state.modal.inviteStructure);
  const handleClose = () => dispatch(setInviteStructureModalClose());
  const { userId, name } = stateModal.props as ModalInviteStructureProps;
  if (!userId) return null;
  return (
    <ModalContainer
      handleClose={handleClose}
      isOpen={stateModal.isOpen}
      header={{
        title: t('modals.inviteStructure.title', { name: name }),
        withButtonClose: true,
      }}
      content={
        <WrapperModalAction closeModal={handleClose}>
          <InviteStructureForm
            onSubmitted={() => handleClose()}
            userId={userId?.toString()}
            onCancel={() => handleClose()}
          />
        </WrapperModalAction>
      }
    />
  );
};
